export const scrollToItemInBox = (target: HTMLElement | Element) => {
	if (!target) return false;

	const xOffset = 150;
	const parent = target.parentElement;
	if (!parent) return false;

	const parentPosX = parent.getBoundingClientRect().left;
	const childrenPosX = target.getBoundingClientRect().left;

	if (parentPosX && childrenPosX) {
		const currentScroll = parent.scrollLeft;
		const position = childrenPosX + currentScroll - parentPosX - xOffset;

		parent.scrollTo({
			left: position,
			behavior: 'smooth',
		});
	}
};
